import React, { useState } from 'react';

import { useAuthContext } from '../../../Auth/AuthProvider';
import { Dropdown } from 'react-bootstrap';
import { GetStageSheet_getStageSheet_details as StageSheet } from '../../../../types/schemaTypes';
import './StageSheet.scss';

interface WeightDetailsProps {
    stageSheetProppantId: number;
    totalWeight: number;
}

interface StageSheetDetailsProps {
    stageSheetBoxId: number;
    station: number;
    weightRemaining: number;
}

interface StageToEditProps {
    weightDetails: WeightDetailsProps[];
    stageSheetDetails: StageSheetDetailsProps[];
}

interface StageSheetEditModeProps {
    stageSheet: StageSheet;
    stagesToEdit: StageToEditProps;
    setStagesToEdit: React.Dispatch<React.SetStateAction<StageToEditProps>>;
    isRevertStageSheetEnabled: boolean;
}

const StageSheetEditMode = ({
    stageSheet,
    stagesToEdit,
    setStagesToEdit,
    isRevertStageSheetEnabled,
}: StageSheetEditModeProps): React.ReactElement => {
    const [station, setStation] = useState(stageSheet.station ?? '');

    const handleOnChangeInput = (value, stageSheetBoxId) => {
        setStation(value);
        const tempStagesToEdit = stagesToEdit;
        let exists = false;
        tempStagesToEdit.stageSheetDetails.map(stageSheetItem => {
            if (stageSheetItem.stageSheetBoxId === stageSheetBoxId) {
                exists = true;
                stageSheetItem.stageSheetBoxId = stageSheetBoxId;
                stageSheetItem.station = value;
                stageSheetItem.weightRemaining = stageSheet.boxWeightRemaining ?? 0;
            }
        });
        if (!exists) {
            tempStagesToEdit.stageSheetDetails.push({
                stageSheetBoxId: stageSheetBoxId,
                station: value,
                weightRemaining: stageSheet.boxWeightRemaining ?? 0,
            });
        }
        setStagesToEdit(tempStagesToEdit);
    };

    return (
        <>
            <tr className="StageSheet-Edit-Item-Container">
                <td>
                    <Dropdown>
                        <Dropdown.Toggle variant="link" className="StageSheet-Station">
                            <span>{station === '0' ? '' : station}</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                // onSelect={() => {
                                //     handleOnChangeInput(1, stageSheet.stageSheetBoxId);
                                // }}
                                onClick={() => {
                                    handleOnChangeInput(1, stageSheet.stageSheetBoxId);
                                }}
                            >
                                1
                            </Dropdown.Item>
                            <Dropdown.Item
                                // onSelect={() => {
                                //     handleOnChangeInput(2, stageSheet.stageSheetBoxId);
                                // }}
                                onClick={() => {
                                    handleOnChangeInput(2, stageSheet.stageSheetBoxId);
                                }}
                            >
                                2
                            </Dropdown.Item>
                            <Dropdown.Item
                                // onSelect={() => {
                                //     handleOnChangeInput(3, stageSheet.stageSheetBoxId);
                                // }}
                                onClick={() => {
                                    handleOnChangeInput(3, stageSheet.stageSheetBoxId);
                                }}
                            >
                                3
                            </Dropdown.Item>
                            <Dropdown.Item
                                // onSelect={() => {
                                //     handleOnChangeInput(4, stageSheet.stageSheetBoxId);
                                // }}
                                onClick={() => {
                                    handleOnChangeInput(4, stageSheet.stageSheetBoxId);
                                }}
                            >
                                4
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </td>
                <td>
                    <div className="StageSheet-GreenDot-Container">
                        {stageSheet.boxDesc}
                        {stageSheet.isPartial === 'Yes' && <div className="StageSheet-GreenDot" />}
                    </div>
                </td>
                <td>{stageSheet.boxWeight}</td>
                <td>{stageSheet.proppant}</td>
                <td>{stageSheet.location}</td>
                <td>{stageSheet.boxWeightRemaining}</td>
                {stageSheet.stageSheetBoxId === 0 ? (
                    <td></td>
                ) : (
                    <td className="StageSheet-Buttons-td">
                        {stageSheet.isOOS ? (
                            <div className="StageSheet-Buttons-Container">
                                Out of Service
                                {isRevertStageSheetEnabled && (
                                    <button className="StageSheet-Buttons StageSheet-Button-Disabled">
                                        Edit Delivered Wt
                                    </button>
                                )}
                            </div>
                        ) : (
                            <div className="StageSheet-Buttons-Container">
                                <button className="StageSheet-Buttons StageSheet-Button-Disabled">OOS</button>
                                {stageSheet.boxWeightRemaining &&
                                stageSheet.boxWeight &&
                                stageSheet.boxWeightRemaining == 0 &&
                                stageSheet.boxWeight > stageSheet.boxWeightRemaining ? (
                                    <></>
                                ) : (
                                    <>
                                        {stageSheet.boxWeightRemaining &&
                                        stageSheet.boxWeight &&
                                        stageSheet.boxWeightRemaining == stageSheet.boxWeight ? (
                                            <>
                                                <button className="StageSheet-Buttons StageSheet-Button-Disabled">
                                                    Partial
                                                </button>
                                                <button className="StageSheet-Buttons StageSheet-Button-Disabled">
                                                    Delete
                                                </button>
                                                <button className="StageSheet-Buttons StageSheet-Button-Disabled">
                                                    Empty
                                                </button>
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                    </>
                                )}
                                {isRevertStageSheetEnabled && (
                                    <button className="StageSheet-Buttons StageSheet-Button-Disabled">
                                        Edit Delivered Wt
                                    </button>
                                )}
                            </div>
                        )}
                    </td>
                )}
                <td>{stageSheet.sandPo}</td>
                <td>{stageSheet.lofaOrigin}</td>
                <td>{stageSheet.sandTicket}</td>
                <td>{stageSheet.loadId}</td>
            </tr>

            {/* {tab view} */}
            <div className="StageSheet-Tab-Item-Container StageSheet-Edit-Item-Container-For-Tab">
                <div className="StageSheet-Tab-Item">
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">Station #:</span>
                        <span className="StageSheet-Value">
                            <Dropdown>
                                <Dropdown.Toggle variant="link" className="StageSheet-Station">
                                    <span>{station === '0' ? '' : station}</span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    <Dropdown.Item
                                        // onSelect={() => {
                                        //     handleOnChangeInput(1, stageSheet.stageSheetBoxId);
                                        // }}
                                        onClick={() => {
                                            handleOnChangeInput(1, stageSheet.stageSheetBoxId);
                                        }}
                                    >
                                        1
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        // onSelect={() => {
                                        //     handleOnChangeInput(2, stageSheet.stageSheetBoxId);
                                        // }}
                                        onClick={() => {
                                            handleOnChangeInput(2, stageSheet.stageSheetBoxId);
                                        }}
                                    >
                                        2
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        // onSelect={() => {
                                        //     handleOnChangeInput(3, stageSheet.stageSheetBoxId);
                                        // }}
                                        onClick={() => {
                                            handleOnChangeInput(3, stageSheet.stageSheetBoxId);
                                        }}
                                    >
                                        3
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                        // onSelect={() => {
                                        //     handleOnChangeInput(4, stageSheet.stageSheetBoxId);
                                        // }}
                                        onClick={() => {
                                            handleOnChangeInput(4, stageSheet.stageSheetBoxId);
                                        }}
                                    >
                                        4
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </span>
                    </div>
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">PO #:</span>
                        <span className="StageSheet-Value">{stageSheet.sandPo}</span>
                    </div>
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">Weight:</span>
                        <span className="StageSheet-Value">{stageSheet.boxWeight}</span>
                    </div>
                </div>

                <div className="StageSheet-Tab-Item StageSheet-Tab-Item-Lg">
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">Type:</span>
                        <span className="StageSheet-Value">{stageSheet.proppant}</span>
                    </div>
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">Pad Location:</span>
                        <span className="StageSheet-Value">{stageSheet.location}</span>
                    </div>
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">Weight Remaining:</span>
                        <span className="StageSheet-Value">{stageSheet.boxWeightRemaining}</span>
                    </div>
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">Origin:</span>
                        <span className="StageSheet-Value">{stageSheet.lofaOrigin}</span>
                    </div>
                </div>

                <div className="StageSheet-Tab-Item">
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">Box:</span>
                        <span className="StageSheet-Value">
                            <div className="StageSheet-GreenDot-Container">
                                {stageSheet.boxDesc}
                                {stageSheet.isPartial === 'Yes' && <div className="StageSheet-GreenDot" />}
                            </div>
                        </span>
                    </div>
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">Ticket #:</span>
                        <span className="StageSheet-Value">{stageSheet.sandTicket}</span>
                    </div>
                    <div className="StageSheet-KeyValues">
                        <span className="StageSheet-Key">Load #:</span>
                        <span className="StageSheet-Value">{stageSheet.loadId}</span>
                    </div>
                </div>

                {stageSheet.isOOS ? (
                    <div className="StageSheet-Tab-Button-Item">
                        Out of Service
                        {isRevertStageSheetEnabled && (
                            <button className="StageSheet-Buttons-For-Tab StageSheet-Button-Disabled StageSheet-LoadWeight-Buttons-For-Tab">
                                Edit Delivered Wt
                            </button>
                        )}
                    </div>
                ) : (
                    <div className="StageSheet-Tab-Button-Item">
                        <button className="StageSheet-Buttons-For-Tab StageSheet-Button-Disabled">OOS</button>
                        {stageSheet.boxWeightRemaining &&
                        stageSheet.boxWeight &&
                        stageSheet.boxWeightRemaining == 0 &&
                        stageSheet.boxWeight > stageSheet.boxWeightRemaining ? (
                            <></>
                        ) : (
                            <>
                                {stageSheet.boxWeightRemaining &&
                                stageSheet.boxWeight &&
                                stageSheet.boxWeightRemaining == stageSheet.boxWeight ? (
                                    <>
                                        <button className="StageSheet-Buttons-For-Tab StageSheet-Button-Disabled">
                                            Partial
                                        </button>
                                        <button className="StageSheet-Buttons-For-Tab StageSheet-Button-Disabled">
                                            Delete
                                        </button>
                                        <button className="StageSheet-Buttons-For-Tab StageSheet-Button-Disabled">
                                            Empty
                                        </button>
                                    </>
                                ) : (
                                    <></>
                                )}
                                {isRevertStageSheetEnabled && (
                                    <button className="StageSheet-Buttons-For-Tab StageSheet-Button-Disabled StageSheet-LoadWeight-Buttons-For-Tab">
                                        Edit Delivered Wt
                                    </button>
                                )}
                            </>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default StageSheetEditMode;
